interface ErrorAlertProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorAlert = ({ message, onRetry }: ErrorAlertProps) => {
  return (
    <div className="rounded-md bg-red-50 p-4 text-red-700">
      <p className="font-medium">Something went wrong</p>
      <p className="text-sm">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 rounded bg-red-100 px-3 py-1 text-sm font-medium hover:bg-red-200"
        >
          Retry
        </button>
      )}
    </div>
  );
};
